import React from "react";
import "./General.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Accordion } from "react-bootstrap";
import faqsImage from "../Assets/faqsimage.svg";
import "./General.css";

const General = () => {
  return (
    <div className="General-page">
      <div className="General-section">
        <h1>General</h1>
        <div>
          <div>
            <Accordion
              defaultActiveKey="0"
              flush
              className="General-background"
            >
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  <h6 className="accordion-text">What is OVest?</h6>
                </Accordion.Header>
                <Accordion.Body className="accordion-bodyText">
                  <p>
                    OVest.ng (OSOURCE VESTMENT LTD) is a product of Osource
                    Empire Limited. OVest was established with the Mission to
                    help individuals, organizations and communities achieve
                    financial security, build wealth and realize their dreams.
                    OVest is a registered and thriving Investment and Funds
                    Management Company managed by a team of experienced and
                    competent professionals in the business of Foreign Exchange
                    Trading, Agriculture, Real Estate, Small Businesses and
                    other investment opportunities offered by the industry.
                  </p>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2" className="General-background-one">
                <Accordion.Header>
                  <h6 className="accordion-text">
                    Why should I invest with OVest ?
                  </h6>
                </Accordion.Header>
                <Accordion.Body className="accordion-bodyText">
                  <p>OVest is suitable for anyone who:</p>
                  <p>● Desire to be financially stable and wealthy.</p>
                  <p>● Never want to miss their investment goals again.</p>
                  <p>
                    ● Want to be in charge of their financial situation and cash
                    flow.
                  </p>
                  <p>
                    ● Realise that allowance, salary and savings is not enough
                    to be rich.
                  </p>
                  <p>
                    ● Want to be capable of handling unforeseen expenses that
                    may arise in future.
                  </p>
                  <p>
                    ● Want a safe place to invest their money and get quality
                    returns even while they are asleep.
                  </p>
                  <p>
                    ● Want a safe place to get high returns for their
                    hard-earned money, unlike what banks offer on savings
                    accounts.
                  </p>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="3" className="General-background-one">
                <Accordion.Header>
                  <h6 className="accordion-text">
                    Is the business duly registered?
                  </h6>
                </Accordion.Header>
                <Accordion.Body className="accordion-bodyText">
                  <p>
                    Yes. OVest is a product of OSource Empire, a union of brands
                    enriching lives and communities daily and we are duly
                    registered with the Corporate Affairs Commission (RC
                    1776455).
                  </p>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="4" className="General-background-one">
                <Accordion.Header>
                  <h6 className="accordion-text">
                    How are you able to offer higher returns?
                  </h6>
                </Accordion.Header>
                <Accordion.Body className="accordion-bodyText">
                  <p>
                    OVest is managed by a team of experienced and competent
                    professionals in the finance and investment industry within
                    and outside the country. The professionals amply understand
                    the volatility that clouds the usage and sourcing of the
                    market. They are duly learned in the field and as such, they
                    use the best analysis and risk management solutions to
                    operate in all investment opportunities offered by the
                    industry to ensure optimum returns consistently.
                  </p>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </div>
      </div>
    </div>
  );
};

export default General;
